// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    typography: {
        fontFamily: {
            title: `Roboto, Helvetica, sans-serif`, // Hercules Custom Code
            base: `Roboto, Helvetica, sans-serif`, // Hercules Custom Code
        },
    },
};

export default design;
